import axios from "axios"
import { okara_api } from "./variables"

// Per-user "apps you last used this on" lists — see RECENT_APPS_API.md.
// Independent lists live on the same okara backend: one per feature that
// writes to it as a side effect of a request it was already serving
// (`/socials/seo/` -> seo_agent, `/socials/recent-intelligence/` ->
// recent_video_intelligence, `/instagram/reel-intelligence/` ->
// instagram_reels_intelligence, `/tiktok/video-intelligence/` ->
// tiktok_video_intelligence, per INSTAGRAM_REEL_API.md §8 /
// TIKTOK_VIDEO_API.md §8 - TikTok's guest single-app claim is independent of
// the other two). Reading this back starts no work and costs nothing, and is
// open to every access level.
const RECENT_APPS_PATH = {
  seo_agent: "/socials/seo/recent-apps/",
  recent_video_intelligence: "/socials/recent-intelligence/recent-apps/",
  instagram_reels_intelligence: "/instagram/reel-intelligence/recent-apps/",
  tiktok_video_intelligence: "/tiktok/video-intelligence/recent-apps/",
  // Ad Discovery's own list, on the `blogApiUrl` backend rather than okara -
  // callers pass `baseUrl: blogApiUrl` (see CreativeInsightsDashboard.jsx).
  facebook_ads: "/ads/api/recent-apps/",
}

const authHeaders = () => {
  const token = localStorage.getItem("authToken")
  return token ? { Authorization: `Bearer ${token}` } : {}
}

/**
 * @param {"seo_agent"|"recent_video_intelligence"|"instagram_reels_intelligence"|"tiktok_video_intelligence"} feature
 * @param {{ limit?: number, baseUrl?: string }} [options]
 */
export async function fetchRecentApps(feature, { limit = 10, baseUrl = okara_api } = {}) {
  const path = RECENT_APPS_PATH[feature]
  if (!path) throw new Error(`Unknown recent-apps feature "${feature}"`)

  const response = await axios.get(`${baseUrl}${path}`, {
    params: { limit },
    headers: authHeaders(),
  })
  return response.data
}
